export class CreateOrganizationIdpResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idp",
            "baseName": "idp",
            "type": "OrganizationIdp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateOrganizationIdpResponse.attributeTypeMap;
    }
    constructor() {
    }
}
